import { Pipe, PipeTransform } from '@angular/core';

import { CompassAccuracy } from '@capgo/capacitor-compass';

import { isEmpty, isNil } from 'lodash-es';

@Pipe({
  name: 'redCompassAccuracy',
  standalone: false
})
export class CompassAccuracyPipe implements PipeTransform {
  transform(value: CompassAccuracy | undefined) {
    let result = '';
    if (!isNil(value)) {
      switch (value) {
        case CompassAccuracy.UNRELIABLE:
          result = 'Unreliable';
          break;
        case CompassAccuracy.LOW:
          result = 'Low';
          break;
        case CompassAccuracy.MEDIUM:
          result = 'Medium';
          break;
        case CompassAccuracy.HIGH:
          result = 'High';
          break;
        default:
          result = 'Unknown';
          break;
      }
    }

    if (isEmpty(result)) {
      result = '--';
    }

    return result;
  }
}
